import { render, staticRenderFns } from "./ProcessTable.vue?vue&type=template&id=68447ffd&"
import script from "./ProcessTable.vue?vue&type=script&lang=js&"
export * from "./ProcessTable.vue?vue&type=script&lang=js&"
import style0 from "./ProcessTable.vue?vue&type=style&index=0&id=68447ffd&prod&langType=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports